import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const total = hotMovies.length;

  const next = useCallback(() => setCurrent((prev) => (prev + 1) % total), [total]);
  const prev = useCallback(() => setCurrent((prev) => (prev - 1 + total) % total), [total]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const movie = hotMovies[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={movie.banner}
          alt={movie.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-background-50" />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/60 to-transparent" />
      </div>

      <div className="relative z-10 h-full mx-auto max-w-[1440px] px-4 md:px-6 flex flex-col justify-end pb-12 md:pb-20">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-3">
            <span className="px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
              正在热映
            </span>
            {movie.tags.slice(0, 2).map((tag) => (
              <span key={tag} className="px-3 py-1 rounded-full border border-foreground-300/30 text-foreground-200 text-xs">
                {tag}
              </span>
            ))}
          </div>
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-50 mb-3">
            {movie.title}
          </h1>
          <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-5 max-w-lg">
            {movie.description}
          </p>
          <div className="flex items-center gap-4">
            <Link
              to={`/article/${movie.id}`}
              className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className="ri-play-fill text-lg" />
              立即观看
            </Link>
            <span className="flex items-center gap-1 text-accent-400 text-sm">
              <i className="ri-star-fill" />
              <span className="font-semibold">{movie.rating}</span>
              <span className="text-foreground-400">/ 豆瓣评分</span>
            </span>
          </div>
        </div>

        <div className="flex items-center gap-2 mt-6">
          {hotMovies.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrent(idx)}
              className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                idx === current ? 'w-8 bg-primary-500' : 'w-1.5 bg-foreground-400/50'
              }`}
              aria-label={`第${idx + 1}张`}
            />
          ))}
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-950/40 backdrop-blur-sm flex items-center justify-center text-foreground-200 hover:text-foreground-50 hover:bg-background-950/60 transition-all cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl" />
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-950/40 backdrop-blur-sm flex items-center justify-center text-foreground-200 hover:text-foreground-50 hover:bg-background-950/60 transition-all cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl" />
      </button>
    </section>
  );
}